import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
  standalone: false,
})
export class InitialsPipe implements PipeTransform {

  transform(fullName?: string | null): string {
    if (!fullName) return '';
    return fullName
      .split(' ')
      .map(part => part.charAt(0).toUpperCase())
      .join('');
  }

}
